import { lazy } from "react";

import type { NavigationRoutingObject, SomeAdditionalSearchableFeature } from "@navigationRouting/types";
import { makeAdditionalSearchableFeature } from "@navigationRouting/utils/makeAdditionalSearchableFeature";

import type { I18nT } from "@lib/dashboardI18n";

const DashboardBuilderWrapper = lazy(() =>
  import("@scenes/DashboardBuilder/DashboardBuilderWrapper").then((module) => ({
    default: module.DashboardBuilderWrapper,
  }))
);

export const dashboardBuilderNRO: NavigationRoutingObject = {
  Component: DashboardBuilderWrapper,
  componentFeatureFlippers: [],
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("dashboard-builder-sidebar-pill-menu-option", "Dashboard Builder"),
  pageNameForTracking: () => "Dashboard Builder",
  getDeveloperNavigationAllowed: ({ isImpersonating, hasPermission }) => {
    const userHasViewAppUsagePermission = hasPermission("appGroup", {
      permission: "viewAppUsage",
    });
    return isImpersonating || userHasViewAppUsagePermission;
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("dashboard-builder-alt-keyword-1", "Dashboard Builder")],
    },
  ],
  additionalSearchableFeatures: (t, { featureOn }): Record<string, SomeAdditionalSearchableFeature> => {
    const features: Record<string, SomeAdditionalSearchableFeature> = {};

    if (featureOn("dashboard_builder_send_outcomes")) {
      features.messaging_diagnostics = makeAdditionalSearchableFeature({
        heading: t("messaging-diagnostics-sidebar-pill-menu-option", "Messaging Diagnostics"),
        pathname: "/dashboard/report_dashboard/:report_dashboard_id/:appGroupId",
        query: { report_dashboard_id: "send-outcomes" },
        description: t(
          "messaging-diagnostics-sidebar-pill-menu-option-description",
          "Troubleshoot and diagnose why messages didn’t send as expected."
        ),
        additionalSearchTerms: [
          {
            keywords: [
              t("messaging-diagnostics-search-keyword", "Messaging Diagnostics Dashboard"),
              t("messaging-diagnostics-search-keyword-mdd", "MDD"),
            ],
          },
        ],
      });
    }

    return features;
  },
  defaultRoute: "/dashboard/report_dashboard/:appGroupId",
  noKnockoutFallback: true,
};
